import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';

export const DisplayAboveMobile = styled(Flex)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DisplayOnMobile = styled(Flex)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: flex;
  }
`;

export const SectionWrapper = styled(Flex)`
  position: relative;
  overflow: hidden;
  background-color: #f8f4ef;
`;

export const StyledRightCloudImage = styled(CloudImage)`
  position: absolute;
  right: 0;
  top: 0;
`;

export const StyledRightMobileCloudImage = styled(CloudImage)`
  position: absolute;
  right: 0;
  bottom: 0;
`;

export const StyledLeftCloudImage = styled(CloudImage)`
  position: absolute;
  left: 0;
  bottom: 0;
`;

export const StyledColumns = styled(Columns)`
  z-index: 1;
  padding: 0 ${themeSpace(1)};
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      padding: 0 ${themeSpace(6)};
    }
  }
`;
